import { DocumentDuplicateIcon, TemplateIcon } from '@heroicons/react/solid';
import type { CellContext, ColumnHelper } from '@tanstack/react-table';
import clsx from 'clsx';

const classes = clsx(
  'inline-flex',
  'items-center',
  'gap-x-1.5',
  'rounded-xl',
  'bg-gray-100',
  'px-3',
  'py-1',
  'text-xs',
  'font-medium',
  'text-gray-800',
);

const iconClasses = clsx('h-4', 'w-4', 'shrink-0');

export const getBaseAccessor = <T extends { sourceResourceDisplayName?: string; sourceResourceId: string }>(
  columnHelper: ColumnHelper<T>,
) =>
  // Undefined, not '', for legacy rows without a stored display name: TanStack sorts undefined values separately.
  columnHelper.accessor((entity) => entity.sourceResourceDisplayName, {
    id: 'sourceResourceDisplayName',
    header: 'Base',
    filterFn: 'arrIncludesSome',
    cell: (cellContext: CellContext<T, string | undefined>) => {
      const sourceResourceDisplayName = cellContext.getValue();
      const sourceResourceId = cellContext.row.original.sourceResourceId;

      const isMRCV3 = sourceResourceId === 'MRC';
      const isBlank = sourceResourceId === 'BLANK';

      const icon =
        isMRCV3 || isBlank ? (
          <TemplateIcon className={iconClasses} />
        ) : (
          <DocumentDuplicateIcon className={iconClasses} />
        );

      const displayName = sourceResourceDisplayName || (isBlank ? 'Blank Template' : sourceResourceDisplayName);

      return (
        <span className={clsx(classes)}>
          {icon}
          {displayName}
        </span>
      );
    },
    meta: {
      filter: {
        placeholder: 'All bases',
      },
    },
  });
